'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ro_RO = require('../../date-picker/locale/ro_RO');

var _ro_RO2 = _interopRequireDefault(_ro_RO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ro_RO2['default'];